<template>
    <div>
      <div class="grid-content maintitle">
        <span>{{$t('message.小美福利信息管理')}}</span>
      </div>
      <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">  
          <el-link
            :underline="false"
            v-if="!isEditMode"
          >
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont" >&#xe618;</i>
              {{$t('message.编辑')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-if="isEditMode"
          >
            <el-button size="medium" round @click="isEditMode=false; refresh();">
              <i class="iconfont" >&#xe600;</i>
              {{$t('message.取消')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
          >
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont" >&#xe667;</i>
              {{$t('message.刷新')}}
            </el-button>
          </el-link>
          <el-link
            :underline="false"
            v-if="isEditMode"
          >
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont" >&#xe769;</i>
              {{$t('message.保存')}}
            </el-button>
          </el-link>
        </div>
      </div>
      </div>
      <div class="grid-content subtitle">
        <span>{{$t('message.关于小美')}}</span>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.顶部图片')}}</span>
            </td>
            <td >
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(1)">
                <i class="iconfont" v-if="!xiaomeiImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img :src="'' + xiaomeiImg" alt="" style="max-width: 500px;max-height: 500px">
                  <img slot="reference" :src="'' + xiaomeiImg">
                  <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle @click.native="xiaomeiImg = '';"></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.头像')}}</span>
            </td>
            <td >
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(2)">
                <i class="iconfont" v-if="!xiaomeiHeadImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img :src="'' + xiaomeiHeadImg" alt="" style="max-width: 500px;max-height: 500px">
                  <img slot="reference" :src="'' + xiaomeiHeadImg">
                  <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle @click.native="xiaomeiHeadImg = '';"></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.昵称')}}</span>
            </td>
            <td >
              <el-input
              :readonly="!isEditMode"
              v-model="xiaomeiNick"
              size="mini"
              maxlength="50"
              :placeholder="$t('message.输入50个以内文字')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.内容')}}</span>
            </td>
            <td >
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="xiaomeiContent"
                type="textarea"
                :placeholder="$t('message.请输入内容')"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.跳转链接')}}</span>
            </td>
            <td >
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="xiaomeiJumpurl"
                type="textarea"
                :placeholder="$t('message.请输入链接')"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
        </table>
      </div>
      <div class="grid-content subtitle">
        <span>{{$t('message.宠粉福利')}}</span>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.顶部图片')}}</span>
            </td>
            <td >
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(3)">
                <i class="iconfont" v-if="!petImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img :src="'' + petImg" alt="" style="max-width: 500px;max-height: 500px">
                  <img slot="reference" :src="'' + petImg">
                  <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle @click.native="petImg = '';"></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.头像')}}</span>
            </td>
            <td >
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(4)">
                <i class="iconfont" v-if="!petHeadImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img :src="'' + petHeadImg" alt="" style="max-width: 500px;max-height: 500px">
                  <img slot="reference" :src="'' + petHeadImg">
                  <el-button v-if="isEditMode" type="danger" icon="el-icon-delete" circle @click.native="petHeadImg = '';"></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.昵称')}}</span>
            </td>
            <td >
              <el-input
              :readonly="!isEditMode"
              v-model="petNick"
              size="mini"
              maxlength="50"
              :placeholder="$t('message.输入50个以内文字')"/>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.内容')}}</span>
            </td>
            <td >
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="petContent"
                type="textarea"
                :placeholder="$t('message.内容')"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{$t('message.跳转链接')}}</span>
            </td>
            <td >
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="petJumpurl"
                type="textarea"
                :placeholder="$t('message.请输入链接')"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
        </table>
      </div>
      <shade v-if="showResourceStore > 0">
        <resource-store
          :shadeShow="showResourceStore > 0"
          @onClick="onResourceStoreCallback"
          :appID="appid"
        ></resource-store>
      </shade>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import {topfixfunc} from "@/utils/topFix";
import ResourceStore from "@/components/resourceStore/resourceStore";
import shade from "@/components/shade/shade";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "Welfare",
  components: {
    shade,
    ResourceStore,
  },
  data() {
    return {
      appid: "188",
      isEditMode: false,
      xiaomeiImg: "",
      xiaomeiHeadImg: "",
      xiaomeiNick: "",
      xiaomeiContent: "",
      xiaomeiJumpurl: "",
      petImg: "",
      petHeadImg: "",
      petNick: "",
      petContent: "",
      petJumpurl: "",
      showResourceStore: false,
    };
  },
  mounted: function () {
    topfixfunc()
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    doSave() {
      this.isEditMode = false;

      this.$http
        .post("/manage/welfare/setinfo", {
          appID: parseInt(this.appid),
          xiaomeiImg: this.xiaomeiImg,
          xiaomeiHeadImg: this.xiaomeiHeadImg,
          xiaomeiNick: this.xiaomeiNick,
          xiaomeiContent: this.xiaomeiContent,
          xiaomeiJumpurl: this.xiaomeiJumpurl,
          petImg: this.petImg,
          petHeadImg: this.petHeadImg,
          petNick: this.petNick,
          petContent: this.petContent,
          petJumpurl: this.petJumpurl,
        })
        .then((doc) => {
          // console.log(doc.data)
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            this.$message({
              type: "success",
              message: doc.data.Message,
            });
          }
        });
    },
    refresh() {
      this.$http
        .get("/manage/welfare/getinfo", {
          params: {
            appid: this.appid,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log(doc.data);
            if (doc.data.data) {
              this.xiaomeiImg = doc.data.data.xiaomeiImg;
              this.xiaomeiHeadImg = doc.data.data.xiaomeiHeadImg;
              this.xiaomeiNick = doc.data.data.xiaomeiNick;
              this.xiaomeiContent = doc.data.data.xiaomeiContent;
              this.xiaomeiJumpurl = doc.data.data.xiaomeiJumpurl;
              this.petImg = doc.data.data.petImg;
              this.petHeadImg = doc.data.data.petHeadImg;
              this.petNick = doc.data.data.petNick;
              this.petContent = doc.data.data.petContent;
              this.petJumpurl = doc.data.data.petJumpurl;
            }
          }
        });
    },
    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
    },
    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        switch (this.showResourceStore) {
          case 1:
            this.xiaomeiImg = doc.resourceID;
            break;
          case 2:
            this.xiaomeiHeadImg = doc.resourceID;
            break;
          case 3:
            this.petImg = doc.resourceID;
            break;
          case 4:
            this.petHeadImg = doc.resourceID;
            break;
        }

        this.showResourceStore = 0;
      } else {
        this.showResourceStore = 0;
      }
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },
  created() {
    this.refresh();
  },
  computed: {},
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/welfare/Welfare.vue